<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{this.$route.meta.title}}
        <div class="card-header-actions">
          <button
            class="btn btn-primary mr-1"
            @click="addpinjaman()"
            v-b-tooltip.hover
            title="input data pinjaman baru"
          >
            <i class="fa fa-floppy-o"></i> {{$t('save')}}
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('cancel')}}
          </button>
        </div>
      </div>

      <div slot="footer">
        <div class="text-center">
          <button
            class="btn btn-primary mr-1"
            @click="addpinjaman()"
            v-b-tooltip.hover
            title="input data pinjaman baru"
          >
            <i class="fa fa-floppy-o"></i> {{$t('save')}}
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('cancel')}}
          </button>
        </div>
      </div>
      <b-tabs content-class justified v-model="tabIndex">
        <b-tab title="DATA DEBITUR" active>
          <b-row>
            <b-col md="7">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:200px;">Nama (sesuai KTP/ Passpor)</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="model.pemohon_name"
                  placeholder
                  :state="!$v.model.pemohon_name.$error"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="7">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:200px;">Tempat/ Tanggal lahir</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="model.tmptlahir"
                  placeholder
                  :state="!$v.model.tmptlahir.$error"
                ></b-form-input>
                <label for="example-datepicker">&nbsp;</label>
                <b-input
                  type="date"
                  :max="minage"
                  v-model="model.tgllahir"
                  :state="!$v.model.tgllahir.$error"
                />
              </b-input-group>
            </b-col>
          </b-row>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width:200px;">Jenis Kelamin</label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.jnskelamin"
              :options="optionsJK"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
            ></b-form-radio-group>
          </b-input-group>

          <b-row>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:200px;">Nomor KTP/ Paspor*</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="model.nomoridentitas"
                  placeholder
                  :state="!$v.model.nomoridentitas.$error"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:150px;" class="text-right mr-1">NPWP Pribadi</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.nonpwp" placeholder :state="!$v.model.nonpwp.$error"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:200px;">Kewarganegaraan</label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.kewarganegaraan"
              :options="optionsWNI"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
              :state="!$v.model.kewarganegaraan.$error"
            ></b-form-radio-group>
          </b-input-group>

          <b-row>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:200px;">Status Perkawinan</label>
                </b-input-group-prepend>
                <b-form-radio-group
                  v-model="model.statusperkawinan"
                  :options="optionsMarried"
                  class="mb-3 mt-1"
                  value-field="item"
                  text-field="name"
                  :state="!$v.model.statusperkawinan.$error"
                ></b-form-radio-group>
              </b-input-group>
            </b-col>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:150px;">Jumlah Tanggungan</label>
                </b-input-group-prepend>
                <my-number style="max-width:70px" v-model="model.jmltanggungan"></my-number>
                <label class="ml-sm-2 mt-1">orang</label>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:200px;">Pendidikan Terakhir</label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.pendidikanterakhir"
              :options="optionsEdu"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
              :state="!$v.model.pendidikanterakhir.$error"
            ></b-form-radio-group>
            <b-form-input
              v-if="model.pendidikanterakhir=='4'"
              placeholder="Sebutkan"
              v-model="model.pendidikanterakhirinput"
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:200px;">Alamat Sesuai KTP/ Passpor</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.alamatktp" placeholder :state="!$v.model.alamatktp.$error"></b-form-input>
          </b-input-group>
          <b-input-group class="sub-section-input">
            <b-input-group-prepend>
              <label class="sub-section-label">Kelurahan</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.kelurahanktp"
              :state="!$v.model.kelurahanktp.$error"
            ></b-form-input>
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">Kecamatan</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.kecamatanktp"
              :state="!$v.model.kecamatanktp.$error"
            ></b-form-input>
          </b-input-group>
          <b-input-group class="sub-section-input">
            <b-input-group-prepend>
              <label class="sub-section-label">Kota</label>
            </b-input-group-prepend>
            <b-form-input placeholder v-model="model.kotaktp" :state="!$v.model.kotaktp.$error"></b-form-input>
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">Propinsi</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.provinsiktp"
              :state="!$v.model.provinsiktp.$error"
            ></b-form-input>
          </b-input-group>
          <b-input-group class="sub-section-input" style="width:calc(50% - 103px)">
            <b-input-group-prepend>
              <label class="sub-section-label">Kodepos</label>
            </b-input-group-prepend>
            <b-form-input placeholder v-model="model.kodeposktp"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:200px;">
                Alamat Tinggal
                <br />(Jika berbeda dengan
                KTP/ Passpor)
              </label>
            </b-input-group-prepend>
            <b-form-input v-model="model.alamat" placeholder></b-form-input>
          </b-input-group>
          <b-input-group class="sub-section-input">
            <b-input-group-prepend>
              <label class="sub-section-label">Kelurahan</label>
            </b-input-group-prepend>
            <b-form-input placeholder v-model="model.kelurahan"></b-form-input>
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">Kecamatan</label>
            </b-input-group-prepend>
            <b-form-input placeholder v-model="model.kecamatan"></b-form-input>
          </b-input-group>
          <b-input-group class="sub-section-input">
            <b-input-group-prepend>
              <label class="sub-section-label">Kota</label>
            </b-input-group-prepend>
            <b-form-input placeholder v-model="model.kota"></b-form-input>
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">Propinsi</label>
            </b-input-group-prepend>
            <b-form-input placeholder v-model="model.provinsi"></b-form-input>
          </b-input-group>
          <b-input-group class="sub-section-input" style="width:calc(50% - 103px)">
            <b-input-group-prepend>
              <label class="sub-section-label">Kodepos</label>
            </b-input-group-prepend>
            <b-form-input placeholde v-model="model.kodepos" r></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:200px;">Status Rumah Tinggal</label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.statusrmhtinggal"
              :options="optionsHome"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
              :state="!$v.model.statusrmhtinggal.$error"
            ></b-form-radio-group>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width:200px;">Lama Tinggal</label>
            </b-input-group-prepend>
            <my-number
              style="max-width:50px"
              class="form-control text-right"
              :precision="0"
              v-model="model.lamatinggalthn"
            ></my-number>
            <b-input-group-append>
              <label class="ml-sm-2 mt-1 mr-3">Tahun</label>
            </b-input-group-append>
            <my-number
              style="max-width:50px"
              class="form-control text-right"
              :precision="0"
              v-model="model.lamatinggalbln"
            ></my-number>
            <label class="ml-sm-2 mt-1">Bulan</label>
          </b-input-group>

          <b-row>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class style="width:200px;">E-mail</label>
                </b-input-group-prepend>
                <b-form-input
                  type="email"
                  v-model="model.email"
                  :state="!$v.model.email.$error"
                  placeholder
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col md="6"></b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:200px;">Nomor Telepon Selular</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="model.nohandphone"
                  :state="!$v.model.nohandphone.$error"
                  placeholder
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:200px;">Nomor Telepon Rumah</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.notlprumah" placeholder></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:200px;">Nama Gadis Ibu Kandung</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.namaibu" :state="!$v.model.namaibu.$error" placeholder></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <!-- <b-card no-body>
            <b-card-text>
              <b-form @submit="event.preventDefault()">
                
              </b-form>
            </b-card-text>
          </b-card>-->
        </b-tab>
        <b-tab>
          <template v-slot:title>DATA DETAIL {{modelpinjaman=='PAB'?'PAB':'PRK'}}</template>
          <b-row>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:200px">No Kontrak</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.no_kontrak" :state="!$v.model.no_kontrak.$error" :disabled="canEdit?'':'disabled'"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:150px" class="text-right mr-2">Tanggal Kontrak</label>
                </b-input-group-prepend>
                <b-form-input
                  type="date"
                  v-model="model.tgl_kontrak"
                  :state="!$v.model.tgl_kontrak.$error"
                  :disabled="canEdit?'':'disabled'"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:200px;">Tujuan Penggunaan</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.uraian"
              :state="!$v.model.uraian.$error"
              placeholder="contoh : pembelian rumah di BSD no 37"
            ></b-form-input>
          </b-input-group>
          <div v-if="modelpinjaman=='PAB'">
            <b-row>
              <b-col md="6">
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;">Pokok Pinjaman</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend>
                    <label style="width:50px;" class="mr-2">IDR</label>
                  </b-input-group-prepend>
                  <my-number
                    v-model="model.principal"
                    :state="!$v.model.principal.$error"
                    :precision="2"
                    class="text-right"
                    :disabled="canEdit?'':'disabled'"
                  ></my-number>

                </b-input-group>
              </b-col>
              <b-col md="6">
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:150px;" class="text-right mr-2">Tenor</label>
                  </b-input-group-prepend>
                  <my-number
                    v-model="model.tenor"
                    :state="!$v.model.tenor.$error"
                    style="max-width:100px;"
                    class="text-right"
                    :disabled="canEdit?'':'disabled'"
                  ></my-number>
                  <b-input-group-append>
                    <label style class="ml-2">Bulan</label>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;">Bunga pinjaman</label>
                  </b-input-group-prepend>
                  <my-number
                    v-model="model.bunga_tarifthn"
                    :state="!$v.model.bunga_tarifthn.$error"
                    :precision="2"
                    style="max-width:100px;"
                    class="text-right"
                    :disabled="canEdit?'':'disabled'"
                  ></my-number>
                  <b-input-group-append>
                    <label style="width:20px;" class="ml-2">%</label>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col md="6">
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:150px;" class="text-right mr-2">Tarif denda harian</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend>
                    <!-- <label style="width:50px;" class="mr-2 text-right">IDR</label> -->
                  </b-input-group-prepend>
                  <my-number
                    v-model="model.denda_tarifhri"
                    :state="!$v.model.denda_tarifhri.$error"
                    :precision="2"
                    style="max-width:100px;"
                    class="text-right"
                    :disabled="canEdit?'':'disabled'"
                  ></my-number>
                    <label style="width:20px;" class="ml-2">%</label>
                </b-input-group>
              </b-col>
            </b-row>
          </div>

          <div v-if="modelpinjaman=='PRK'">
            <b-row>
              <b-col md="7">
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;">Maksimal Pinjaman</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend>
                    <label style="width:50px;" class="mr-2">IDR</label>
                  </b-input-group-prepend>
                  <my-number
                    v-model="model.principal"
                    :state="!$v.model.principal.$error"
                    :precision="2"
                    class="text-right"
                  ></my-number>
                </b-input-group>
              </b-col>
              <b-col md="5">
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:150px;">Tenor</label>
                  </b-input-group-prepend>
                  <my-number
                    v-model="model.tenor"
                    :state="!$v.model.tenor.$error"
                    style="max-width:100px;"
                    class="text-right"
                    @change="changeduedate"
                  ></my-number>
                  <b-input-group-append>
                    <label style class="ml-2">Bulan</label>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="7">
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;">Bunga per Tahun</label>
                  </b-input-group-prepend>
                  <my-number
                    v-model="model.bunga_tarifthn"
                    :state="!$v.model.bunga_tarifthn.$error"
                    style="max-width:100px;"
                    class="text-right"
                  ></my-number>
                  <b-input-group-append>
                    <label style="width:20px;" class="ml-2">%</label>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col md="5">
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:150px;">Bunga OD</label>
                  </b-input-group-prepend>
                  <my-number
                    v-model="model.bungaod_tarifthn"
                    :state="!$v.model.bungaod_tarifthn.$error"
                    style="max-width:100px;"
                    class="text-right"
                  ></my-number>

                  <b-input-group-append>
                    <label style="width:20px;" class="ml-2">%</label>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:200px;">Tanggal Cair</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="model.startdate"
                  :state="!$v.model.startdate.$error"
                  :precision="2"
                  class="text-right"
                  @change="changeduedate"
                  type="date"
                  :min="new Date() | moment('YYYY-MM-DD')"
                  :disabled="canEdit?'':'disabled'"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col md="5">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:150px;" class="text-right mr-2">Jatuh Tempo Kontrak</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="model.duedate"
                  :state="!$v.model.duedate.$error"
                  :precision="2"
                  class="text-right"
                  type="date"
                  :disabled="canEdit?'':'disabled'"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6"></b-col>
            <b-col md="6"></b-col>
          </b-row>
        </b-tab>
        <b-tab title="DATA AGUNAN">
          <b-table responsive hover bordered :items="listAgunan" :fields="fieldsAgunan">
            <template v-slot:cell(index)="data">{{data.index +1}}</template>
            <template v-slot:cell(nilaijaminan)="data">{{data.item.nilaijaminan | numFormat}}</template>

            <template v-slot:cell(alamat)="data">
              {{data.item.alamat}}
              <br />
              Kelurahan : {{data.item.kelurahan}} - Kecamatan :{{data.item.kecamatan}}
              <br />
              Kota : {{data.item.kota}} - Provinsi :{{data.item.provinsi}}
              <br />
              Kode Pos : {{data.item.kodepos}}
            </template>
            <template v-slot:cell(detail)="data">
              <span v-if="data.item.tipejaminan=='Kendaraan'">
                <b-row>
                  <b-col md="6">- No. BPKB : {{data.item.bpkb}}</b-col>
                  <b-col md="6">- No. STNK : {{data.item.stnk}}</b-col>
                </b-row>
                <b-row>
                  <b-col md="6">- Status STNK : {{data.item.statusstnk}}</b-col>
                  <b-col md="6">- Tanggal STNK : {{data.item.tanggalstnk}}</b-col>
                </b-row>
              </span>
              <span v-else>
                <b-row>
                  <b-col md="6">
                    - Luas Tanah : {{data.item.luastanah}} m
                    <sup>2</sup>
                  </b-col>
                  <b-col md="6">
                    - Luas Bangunan : {{data.item.luasbangunan}} m
                    <sup>2</sup>
                  </b-col>
                </b-row>
                - Status Sertifikat : {{data.item.sertifikatstatus}}
                <span
                  v-if="data.item.sertifikatstatus==='lainnya'"
                >- {{data.item.otherstatussertifikat}}</span>
                <b-row>
                  <b-col md="6">- No Sertifikat : {{data.item.sertifikatno}}</b-col>
                  <b-col md="6">- Sertifikat Atas Nama : {{data.item.pemilikjaminan}}</b-col>
                </b-row>
                <b-row>
                  <b-col md="6">- Status PBB : {{data.item.statuspbb}}</b-col>
                  <b-col md="6">- Tanggal PBB: {{data.item.tanggalpbb}}</b-col>
                </b-row>
                <b-row>
                  <b-col md="6">- Status Asuransi : {{data.item.statusasuransi}}</b-col>
                  <b-col md="6">- No. IMB : {{data.item.noimb}}</b-col>
                </b-row>
              </span>
            </template>
            <template v-slot:cell(action)="data">
              <div class="text-center">
                {{data.item.namajaminan}}
                <a
                  href="javascript:void(0)"
                  @click="editLineAngunan(data.item)"
                >
                  <i class="fa fa-pencil"></i>
                </a>
                |
                <a
                  href="javascript:void(0)"
                  class="text-danger"
                  @click="delAgunan(data.index)"
                >
                  <i class="fa fa-trash"></i>
                </a>
              </div>
            </template>
          </b-table>
          <hr />
          <div class="text-right">
            <b-button variant="primary" @click="tambahagunan">
              <i class="fa fa-plus"></i> Tambah Agunan
            </b-button>
          </div>
        </b-tab>
        <b-tab>
          <template v-slot:title>
            <div title style="width: 258px;">DATA KELUARGA TIDAK SERUMAH</div>
          </template>
          <b-row>
            <b-col md="7">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:200px;">Nama</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="model.namareferensi"
                  :state="!$v.model.namareferensi.$error"
                  placeholder
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="7">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:200px;">Hubungan</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="model.hubunganreferensi"
                  :state="!$v.model.hubunganreferensi.$error"
                  placeholder
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width:200px;">
                Alamat Tempat Tinggal
                <br />Referensi Saat Ini
              </label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.alamatreferensi"
              :state="!$v.model.alamatreferensi.$error"
              placeholder
            ></b-form-input>
          </b-input-group>
          <b-input-group class="sub-section-input">
            <b-input-group-prepend>
              <label class="sub-section-label">Kelurahan</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.kelurahanreferensi"
              :state="!$v.model.kelurahanreferensi.$error"
            ></b-form-input>
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">Kecamatan</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.kecamatanreferensi"
              :state="!$v.model.kecamatanreferensi.$error"
            ></b-form-input>
          </b-input-group>
          <b-input-group class="sub-section-input">
            <b-input-group-prepend>
              <label class="sub-section-label">Kota</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.kotareferensi"
              :state="!$v.model.kotareferensi.$error"
            ></b-form-input>
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">Propinsi</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.provinsireferensi"
              :state="!$v.model.provinsireferensi.$error"
            ></b-form-input>
          </b-input-group>
          <b-input-group class="sub-section-input" style="width:calc(50% - 103px)">
            <b-input-group-prepend>
              <label class="sub-section-label">Kodepos</label>
            </b-input-group-prepend>
            <b-form-input placeholder v-model="model.kodeposreferensi"></b-form-input>
          </b-input-group>
          <b-row>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:200px;">Nomor Telepon Selular</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="model.nohpreferensi"
                  :state="!$v.model.nohpreferensi.$error"
                  placeholder
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:150px;" class="text-right mr-2">Nomor Telepon Rumah</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.notlpreferensi" placeholder></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="DATA PEKERJAAN">
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:200px;">Pekerjaan</label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.tipepekerjaan"
              :options="optionsJob"
              :state="!$v.model.tipepekerjaan.$error"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
            ></b-form-radio-group>
          </b-input-group>

          <b-input-group v-if="ifkaryawan">
            <b-input-group-prepend>
              <label style="width:200px;">
                Status Pekerjaan
                <br />(jika karyawan)
              </label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.statuspekerjaan"
              :options="optionsJobStatus"
              :state="!$v.model.statuspekerjaan.$error"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
            ></b-form-radio-group>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width:200px;">Nama Perusahaan</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.namaperusahaan"
              :state="!$v.model.namaperusahaan.$error"
              placeholder
            ></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width:200px;">Alamat Perusahaan</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.alamatperusahaan"
              :state="!$v.model.alamatperusahaan.$error"
              placeholder
            ></b-form-input>
          </b-input-group>
          <b-input-group class="sub-section-input">
            <b-input-group-prepend>
              <label class="sub-section-label">Kota</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.kotaperusahaan"
              :state="!$v.model.kotaperusahaan.$error"
            ></b-form-input>
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">Propinsi</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.provinsiperusahaan"
              :state="!$v.model.provinsiperusahaan.$error"
            ></b-form-input>
          </b-input-group>
          <b-input-group class="sub-section-input" style="width:calc(50% - 103px)">
            <b-input-group-prepend>
              <label class="sub-section-label">Kodepos</label>
            </b-input-group-prepend>
            <b-form-input placeholder v-model="model.kodeposperusahaan"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:200px;">Nomor Telepon Kantor</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.notlpperusahaan"
              :state="!$v.model.notlpperusahaan.$error"
              placeholder
            ></b-form-input>
            <b-input-group-prepend>
              <label class="sub-section-label mr-2 text-right">Faks Kantor</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.nofaxperusahaan" placeholder></b-form-input>
          </b-input-group>
          <b-row>
            <b-col md="7">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:200px;">Lama Bekerja/usaha/praktek*</label>
                </b-input-group-prepend>
                <b-form-select
                  v-model="model.lamabekerja"
                  :options="optionsExp"
                  class="mb-3"
                  :state="!$v.model.lamabekerja.$error"
                ></b-form-select>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group v-if="model.tipepekerjaan!=='0'">
            <b-input-group-prepend>
              <label style="width:200px;">
                Kepemilikan Tempat Usaha
                <br />(Jika profesional/wiraswasta)
              </label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.kepemilikanusaha"
              :options="optionsOwner"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
            ></b-form-radio-group>
          </b-input-group>
          <b-row>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:200px;">Sebelumnya Bekerja Di</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.pekerjaansblm_tmpt" placeholder></b-form-input>
              </b-input-group>
            </b-col>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:150px;" class="text-right mr-2">Lama Bekerja</label>
                </b-input-group-prepend>
                <b-form-input
                  style="max-width:70px"
                  placeholder
                  v-model="model.lamakerjasblm_thn"
                  class="text-right"
                ></b-form-input>
                <label class="ml-sm-2 mt-1 mr-3">Tahun</label>
                <b-form-input
                  style="max-width:70px"
                  placeholder
                  v-model="model.lamakerjasblm_bln"
                  class="text-right"
                ></b-form-input>
                <label class="ml-sm-2 mt-1">Bulan</label>
              </b-input-group>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>

      <!-- <b-card
        header="DATA SUAMI/ISTRI DEBITUR"
        header-text-variant="black"
        header-tag="header"
        header-bg-variant="white"
      >
        <b-input-group>
          <b-input-group-prepend>
            <label style="width:200px;">Nama (sesuai KTP/ Passpor*)</label>
          </b-input-group-prepend>
          <b-form-input
            v-model="model.namapasangan"
            :state="!$v.model.namapasangan.$error"
            placeholder
          ></b-form-input>
        </b-input-group>

        <b-input-group>
          <b-input-group-prepend>
            <label style="width:200px;">Tempat/ Tanggal lahir</label>
          </b-input-group-prepend>
          <b-form-input
            v-model="model.tmptlahirpasangan"
            :state="!$v.model.tmptlahirpasangan.$error"
            placeholder
          ></b-form-input>
          <label for="example-datepicker">&nbsp;</label>
          <b-input
            type="date"
            v-model="model.tgllahirpasangan"
            :state="!$v.model.tgllahirpasangan.$error"
          />
        </b-input-group>

        <b-input-group>
          <b-input-group-prepend>
            <label style="width:200px;">Nomor KTP/ Paspor*</label>
          </b-input-group-prepend>
          <b-form-input
            v-model="model.noidentitaspasangan"
            :state="!$v.model.noidentitaspasangan.$error"
            placeholder
          ></b-form-input>
        </b-input-group>

        <b-input-group>
          <b-input-group-prepend>
            <label style="width:200px;">Pendidikan Terakhir</label>
          </b-input-group-prepend>
          <b-form-radio-group
            v-model="model.pendidikanpasangan"
            :options="optionsEdu"
            :state="!$v.model.pendidikanpasangan.$error"
            class="mb-3 mt-1"
            value-field="item"
            text-field="name"
          ></b-form-radio-group>
          <b-form-input v-if="model.pendidikanpasangan=='4'" placeholder="Sebutkan"></b-form-input>
        </b-input-group>

        <b-input-group>
          <b-input-group-prepend>
            <label style="width:200px;">Pekerjaan</label>
          </b-input-group-prepend>
          <b-form-radio-group
            v-model="model.pekerjaanpasangan"
            :state="!$v.model.pekerjaanpasangan.$error"
            :options="optionsJob"
            class="mb-3 mt-1"
            value-field="item"
            text-field="name"
          ></b-form-radio-group>
        </b-input-group>

        <b-input-group>
          <b-input-group-prepend>
            <label style="width:200px;">Nama Perusahaan</label>
          </b-input-group-prepend>
          <b-form-input
            v-model="model.nmperusahnpasangan"
            :state="!$v.model.nmperusahnpasangan.$error"
            placeholder
          ></b-form-input>
        </b-input-group>

        <b-input-group>
          <b-input-group-prepend>
            <label style="width:200px;">Alamat Perusahaan</label>
          </b-input-group-prepend>
          <b-form-input
            v-model="model.almtperusahnpasangan"
            :state="!$v.model.almtperusahnpasangan.$error"
            placeholder
          ></b-form-input>
        </b-input-group>
        <b-input-group class="sub-section-input">
          <b-input-group-prepend>
            <label class="sub-section-label">Kota</label>
          </b-input-group-prepend>
          <b-form-input
            placeholder
            v-model="model.kotaperusahnpasangan"
            :state="!$v.model.kotaperusahnpasangan.$error"
          ></b-form-input>
          <b-input-group-prepend>
            <label class="sub-section-label text-right mr-2">Propinsi</label>
          </b-input-group-prepend>
          <b-form-input
            placeholder
            v-model="model.provperusahnpasangan"
            :state="!$v.model.provperusahnpasangan.$error"
          ></b-form-input>
        </b-input-group>
        <b-input-group class="sub-section-input" style="width:calc(50% - 103px)">
          <b-input-group-prepend>
            <label class="sub-section-label">Kodepos</label>
          </b-input-group-prepend>
          <b-form-input placeholder v-model="model.kdposperusahnpasangan"></b-form-input>
        </b-input-group>
        <b-row>
          <b-col md="7">
            <b-input-group>
              <b-input-group-prepend>
                <label style="width:200px;">Lama Bekerja/usaha/praktek*</label>
              </b-input-group-prepend>
              <b-form-select
                v-model="model.lamabekerjapasangan"
                :state="!$v.model.lamabekerjapasangan.$error"
                :options="optionsExp"
                class="mb-3"
              ></b-form-select>
            </b-input-group>
          </b-col>
        </b-row>

        <b-input-group v-if="model.pekerjaanpasangan !=='0'">
          <b-input-group-prepend>
            <label style="width:200px;">
              Kepemilikan Tempat Usaha
              <br />(Jika profesional/wiraswasta)
            </label>
          </b-input-group-prepend>
          <b-form-radio-group
            v-model="model.kepmlknusahapasangan"
            :options="optionsOwner"
            class="mb-3 mt-1"
            value-field="item"
            text-field="name"
          ></b-form-radio-group>
        </b-input-group>
        <b-row>
          <b-col md="7">
            <b-input-group>
              <b-input-group-prepend>
                <label style="width:200px;">Email</label>
              </b-input-group-prepend>
              <b-form-input
                v-model="model.emailpasangan"
                :state="!$v.model.emailpasangan.$error"
                placeholder
              ></b-form-input>
            </b-input-group>
          </b-col>
          <b-col md="5">
            <b-input-group>
              <b-input-group-prepend>
                <label class="text-right mr-2">No.Tlp. Selular</label>
              </b-input-group-prepend>
              <b-form-input
                v-model="model.nohandphonepasangan"
                :state="!$v.model.nohandphonepasangan.$error"
                placeholder
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
      </b-card>-->

      <!-- <b-card
        header="DATA PENGHASILAN & PENGELUARAN"
        header-text-variant="black"
        header-tag="header"
        header-bg-variant="white"
      >
        <b-row>
          <b-col md="6">
            <b-input-group>
              <b-input-group-prepend>
                <label style="width:200px;">Penghasilan/gaji bersih</label>
              </b-input-group-prepend>
              <b-input-group-prepend>
                <label class="mr-3" style="width:20px !important;">Rp.</label>
              </b-input-group-prepend>
              <my-number class="mynumb-penghasilan text-right" v-model="model.gaji" :precision="2"></my-number>
              <b-input-group-append>
                <label class="ml-1" style="width:20px !important;">/bulan</label>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col md="6">
            <b-input-group>
              <b-input-group-prepend>
                <label style="width:200px;">Total pengeluaran rutin</label>
              </b-input-group-prepend>
              <b-input-group-prepend>
                <label class="mr-3" style="width:20px !important;">Rp.</label>
              </b-input-group-prepend>
              <my-number
                class="mynumb-penghasilan text-right"
                v-model="model.totalpengeluaran"
                :precision="2"
              ></my-number>
              <b-input-group-append>
                <label class="ml-1" style="width:20px !important;">/bulan</label>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-input-group>
              <b-input-group-prepend>
                <label style="width:200px;">Penghasilan suami/istri</label>
              </b-input-group-prepend>
              <b-input-group-prepend>
                <label class="mr-3" style="width:20px !important;">Rp.</label>
              </b-input-group-prepend>
              <my-number
                class="mynumb-penghasilan text-right"
                v-model="model.penghasilanpasangan"
                :precision="2"
              ></my-number>
              <b-input-group-append>
                <label class="ml-1" style="width:20px !important;">/bulan</label>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col md="6">
            <b-input-group>
              <b-input-group-prepend>
                <label style="width:200px;">Sisa pendapatan</label>
              </b-input-group-prepend>
              <b-input-group-prepend>
                <label class="mr-3" style="width:20px !important;">Rp.</label>
              </b-input-group-prepend>
              <my-number
                class="mynumb-penghasilan text-right"
                v-model="model.sisapendapatan"
                :precision="2"
              ></my-number>
              <b-input-group-append>
                <label class="ml-1" style="width:20px !important;">/bulan</label>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-input-group>
              <b-input-group-prepend>
                <label style="width:200px;">Penghasilan rutin tambahan</label>
              </b-input-group-prepend>
              <b-input-group-prepend>
                <label class="mr-3" style="width:20px !important;">Rp.</label>
              </b-input-group-prepend>
              <my-number
                class="mynumb-penghasilan text-right"
                v-model="model.penghasilantambahan"
                :precision="2"
              ></my-number>
              <b-input-group-append>
                <label class="ml-1" style="width:20px !important;">/bulan</label>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-input-group>
              <b-input-group-prepend>
                <label style="width:200px;">Total penghasilan</label>
              </b-input-group-prepend>
              <b-input-group-prepend>
                <label class="mr-3" style="width:20px !important;">Rp.</label>
              </b-input-group-prepend>
              <my-number
                class="mynumb-penghasilan text-right"
                v-model="model.totalpenghasilan"
                :precision="2"
              ></my-number>
              <b-input-group-append>
                <label class="ml-1" style="width:20px !important;">/bulan</label>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
      </b-card>-->
      <!-- <b-card
        header="DATA PINJAMAN LAINNYA"
        header-text-variant="black"
        header-tag="header"
        header-bg-variant="white"
      >
        <b-table
          class="mb-0"
          ref="table"
          outlined
          responsive
          bordered
          hover
          small
          style="font-size:smaller;"
          :items="otherKreditDt"
          :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit"
          show-empty
        >
          <template v-slot:cell(pemberipinjaman)="data">
            <b-form-input v-model="data.item.pemberipinjaman" placeholder="Nama pemberi pinjaman"></b-form-input>
          </template>
          <template v-slot:cell(namapeminjam)="data">
            <b-form-input v-model="data.item.namapeminjam" placeholder="Nama peminjam"></b-form-input>
          </template>
          <template v-slot:cell(sisajangkawaktu)="data">
            <b-input-group>
              <my-number v-model="data.item.sisajangkawaktu" class="text-right"></my-number>
              <b-input-group-append>
                <label class="mr-2 ml-2">/bulan</label>
              </b-input-group-append>
            </b-input-group>
          </template>
          <template v-slot:cell(saldopinjaman)="data">
            <b-input-group>
              <b-input-group-prepend>
                <label class="mr-2" style="width:20px !important;">Rp.</label>
              </b-input-group-prepend>
              <my-number v-model="data.item.saldopinjaman" :precision="2" class="text-right"></my-number>
            </b-input-group>
          </template>
          <template v-slot:cell(angsuran)="data">
            <b-input-group>
              <b-input-group-prepend>
                <label class="mr-2 mt-2" style="width:20px !important;">Rp.</label>
              </b-input-group-prepend>
              <my-number v-model="data.item.angsuran" :precision="2" class="text-right"></my-number>
            </b-input-group>
          </template>

          <template v-slot:cell(empty)="data">
            <h4>{{ data.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
        </b-table>
        <b-row>
          <b-col class="text-right">
            <b-button size="sm" @click="addpinjamanother">
              <i class="fa fa-plus"></i> Tambah Pinjaman
            </b-button>
          </b-col>
        </b-row>
      </b-card>-->
    </b-card>
    <b-modal
      v-model="showObjAgunan"
      size="lg"
      title="Detail Agunan"
      :centered="true"
      @ok="saveagunan"
    >
      <!-- <b-card> -->
      <b-input-group>
        <b-input-group-prepend>
          <label class="lbl-left pt-0">Tipe Jaminan</label>
        </b-input-group-prepend>
        <b-form-radio-group
          id="tipejaminan"
          v-model="objAgunan.tipejaminan"
          :state="!$v.objAgunan.tipejaminan.$error"
          :options="optTipeJaminan"
        ></b-form-radio-group>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend>
          <label class="lbl-left">Nama Jaminan</label>
        </b-input-group-prepend>
        <b-form-input
          v-model="objAgunan.namajaminan"
          :state="!$v.objAgunan.namajaminan.$error"
          placeholder="Mobil Alphard / Rumah tinggal mewah"
        ></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend>
          <label class="lbl-left">Alamat Jaminan</label>
        </b-input-group-prepend>
        <b-form-input v-model="objAgunan.alamat" :state="!$v.objAgunan.alamat.$error"></b-form-input>
      </b-input-group>
      <b-input-group class="sub-section-input">
        <b-input-group-prepend>
          <label class="sub-section-label">Kelurahan</label>
        </b-input-group-prepend>
        <b-form-input
          placeholder
          v-model="objAgunan.kelurahan"
          :state="!$v.objAgunan.kelurahan.$error"
        ></b-form-input>
        <b-input-group-prepend>
          <label class="sub-section-label text-right mr-2">Kecamatan</label>
        </b-input-group-prepend>
        <b-form-input
          placeholder
          v-model="objAgunan.kecamatan"
          :state="!$v.objAgunan.kecamatan.$error"
        ></b-form-input>
      </b-input-group>
      <b-input-group class="sub-section-input">
        <b-input-group-prepend>
          <label class="sub-section-label">Kota</label>
        </b-input-group-prepend>
        <b-form-input placeholder v-model="objAgunan.kota" :state="!$v.objAgunan.kota.$error"></b-form-input>
        <b-input-group-prepend>
          <label class="sub-section-label text-right mr-2">Propinsi</label>
        </b-input-group-prepend>
        <b-form-input
          placeholder
          v-model="objAgunan.provinsi"
          :state="!$v.objAgunan.provinsi.$error"
        ></b-form-input>
      </b-input-group>
      <b-input-group class="sub-section-input" style="width:calc(50% - 103px)">
        <b-input-group-prepend>
          <label class="sub-section-label">Kodepos</label>
        </b-input-group-prepend>
        <b-form-input placeholder v-model="objAgunan.kodepos"></b-form-input>
      </b-input-group>

      <div v-if="objAgunan.tipejaminan=='Kendaraan'">
        <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend>
                <label class="lbl-left">Pemilik A/N</label>
              </b-input-group-prepend>
              <b-form-input
                v-model="objAgunan.pemilikjaminan"
                :state="!$v.objAgunan.pemilikjaminan.$error"
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">No. BPKB</label>
          </b-input-group-prepend>
          <b-form-input v-model="objAgunan.bpkb" :state="!$v.objAgunan.bpkb.$error"></b-form-input>
          <b-input-group-prepend>
            <label class="sub-section-label text-right mr-2">No. STNK</label>
          </b-input-group-prepend>
          <b-form-input v-model="objAgunan.stnk" :state="!$v.objAgunan.stnk.$error"></b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">Status STNK</label>
          </b-input-group-prepend>
          <b-form-input v-model="objAgunan.statusstnk" :state="!$v.objAgunan.statusstnk.$error"></b-form-input>
          <b-input-group-prepend>
            <label class="sub-section-label text-right mr-2">Tanggal STNK</label>
          </b-input-group-prepend>
          <b-form-input
            type="date"
            v-model="objAgunan.tanggalstnk"
            :state="!$v.objAgunan.tanggalstnk.$error"
          ></b-form-input>
        </b-input-group>
      </div>
      <div v-if="objAgunan.tipejaminan=='FA'">
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">Luas Tanah</label>
          </b-input-group-prepend>
          <my-number
            style="max-width:150px"
            v-model="objAgunan.luastanah"
            :state="!$v.objAgunan.luastanah.$error"
          ></my-number>
          <b-input-group-append>
            <label class="ml-2 mr-5">
              /m
              <sup>2</sup>
            </label>
          </b-input-group-append>
          <b-input-group-prepend>
            <label class="sub-section-label text-right mr-2">Luas Bangunan</label>
          </b-input-group-prepend>
          <my-number
            style="max-width:150px"
            v-model="objAgunan.luasbangunan"
            :state="!$v.objAgunan.luasbangunan.$error"
          ></my-number>
          <b-input-group-append>
            <label class="ml-2">
              /m
              <sup>2</sup>
            </label>
          </b-input-group-append>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">Status Sertifikat</label>
          </b-input-group-prepend>
          <b-form-radio-group
            v-model="objAgunan.sertifikatstatus"
            :state="!$v.objAgunan.sertifikatstatus.$error"
            :options="optStsSertifikat"
          ></b-form-radio-group>
          <b-form-input
            v-if="objAgunan.sertifikatstatus =='lainnya'"
            placeholder="Sebutkan"
            v-model="objAgunan.otherstatussertifikat"
            :state="!$v.objAgunan.otherstatussertifikat.$error"
          ></b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">No Sertifikat</label>
          </b-input-group-prepend>
          <b-form-input v-model="objAgunan.sertifikatno" :state="!$v.objAgunan.sertifikatno.$error"></b-form-input>
          <b-input-group-prepend>
            <label class="sub-section-label text-right mr-2">Sertifikat Atas Nama</label>
          </b-input-group-prepend>
          <b-form-input
            v-model="objAgunan.pemilikjaminan"
            :state="!$v.objAgunan.pemilikjaminan.$error"
          ></b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">Status PBB</label>
          </b-input-group-prepend>
          <b-form-input v-model="objAgunan.statuspbb" :state="!$v.objAgunan.statuspbb.$error"></b-form-input>
          <b-input-group-prepend>
            <label class="sub-section-label text-right mr-2">Tanggal PBB</label>
          </b-input-group-prepend>
          <b-form-input
            type="date"
            v-model="objAgunan.tanggalpbb"
            :state="!$v.objAgunan.tanggalpbb.$error"
          ></b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">Status Asuransi</label>
          </b-input-group-prepend>
          <b-form-input
            v-model="objAgunan.statusasuransi"
            :state="!$v.objAgunan.statusasuransi.$error"
          ></b-form-input>
          <b-input-group-prepend>
            <label class="sub-section-label text-right mr-2">No. IMB</label>
          </b-input-group-prepend>
          <b-form-input v-model="objAgunan.noimb" :state="!$v.objAgunan.noimb.$error"></b-form-input>
        </b-input-group>
      </div>
      <b-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label class="lbl-left">Nilai Jaminan</label>
            </b-input-group-prepend>
            <b-input-group-prepend>
              <label class="mr-3" style="width:20px !important;">Rp.</label>
            </b-input-group-prepend>
            <my-number
              class="mynumb-penghasilan text-right"
              v-model="objAgunan.nilaijaminan"
              :state="!$v.objAgunan.nilaijaminan.$error"
              :precision="2"
            ></my-number>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">Hub. Dgn Peminjam</label>
            </b-input-group-prepend>
            <b-form-input v-model="objAgunan.hubungandgnpemilik"></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>

      <!-- </b-card> -->
      <template v-slot:modal-footer="{ ok, cancel, hide }">
        <b-button variant="success" @click="ok()">
          <i class="fa fa-floppy-o"></i> Update Agunan
        </b-button>
        <b-button variant="danger" @click="cancel()">Cancel</b-button>
      </template>
    </b-modal>
    <b-modal
      v-model="showDelConfirm"
      size="sm"
      title="Detail Agunan"
      :centered="true"
      @ok="saveagunan"
    ></b-modal>
  </div>
</template>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import { validationMixin } from "vuelidate";
import { required, minValue, requiredIf } from "vuelidate/lib/validators";
import aplikasi from "../../apis/pinjamankredit";
toastr.init();
export default {
  components: { myNumber },
  mixins: [validationMixin],
  validations: {
    objAgunan: {
      tipejaminan: { required },
      namajaminan: { required },
      alamat: { required },
      kelurahan: { required },
      kecamatan: { required },
      kota: { required },
      provinsi: { required },
      // kodepos
      bpkb: {
        required: requiredIf(function (value) {
          return this.ifKendaraan;
        }),
      },
      stnk: {
        required: requiredIf(function (value) {
          return this.ifKendaraan;
        }),
      },
      statusstnk: {
        required: requiredIf(function (value) {
          return this.ifKendaraan;
        }),
      },
      tanggalstnk: {
        required: requiredIf(function (value) {
          return this.ifKendaraan;
        }),
      },
      luastanah: {
        required: requiredIf(function (value) {
          return this.ifFAsset;
        }),
      },
      luasbangunan: {
        required: requiredIf(function (value) {
          return this.ifFAsset;
        }),
      },
      sertifikatno: {
        required: requiredIf(function (value) {
          return this.ifFAsset;
        }),
      },
      sertifikatstatus: {
        required: requiredIf(function (value) {
          return this.ifFAsset;
        }),
      },
      otherstatussertifikat: {
        required: requiredIf(function (value) {
          return this.ifstssrtfkother;
        }),
      },
      statusasuransi: {
        required: requiredIf(function (value) {
          return this.ifFAsset;
        }),
      },
      tanggalpbb: {
        required: requiredIf(function (value) {
          return this.ifFAsset;
        }),
      },
      statuspbb: {
        required: requiredIf(function (value) {
          return this.ifFAsset;
        }),
      },
      noimb: {
        required: requiredIf(function (value) {
          return this.ifFAsset;
        }),
      },
      pemilikjaminan: {
        required,
        // : requiredIf(function (value) {
        //   return this.ifFAsset;
        // }),
      },
      // hubungandgnpemilik
      nilaijaminan: { required },
    },
    model: {
      no_kontrak: { required },
      tgl_kontrak: { required },
      uraian: { required },
      tenor: { required },
      principal: { required },
      // interest: { required },
      bunga_tarifthn: { required },
      denda_tarifhri: { required },
      bungaod_tarifthn: {
        required: requiredIf(function (value) {
          return this.ifPRK;
        }),
      },
      startdate: { required },
      duedate: { required },

      pemohon_name: { required },
      tmptlahir: { required },
      tgllahir: { required },
      nomoridentitas: { required },
      nonpwp: { required: false },
      kewarganegaraan: { required },
      statusperkawinan: { required },
      pendidikanterakhir: { required },
      alamatktp: { required },
      kelurahanktp: { required },
      kecamatanktp: { required },
      kotaktp: { required },
      provinsiktp: { required },
      statusrmhtinggal: { required },
      nohandphone: { required },
      email: { required },
      namaibu: { required },
      namareferensi: { required },
      hubunganreferensi: { required },
      alamatreferensi: { required },
      kelurahanreferensi: { required },
      kecamatanreferensi: { required },
      kotareferensi: { required },
      provinsireferensi: { required },
      nohpreferensi: { required },
      tipepekerjaan: { required },
      statuspekerjaan: {
        required: requiredIf(function (value) {
          return this.ifkaryawan;
        }),
      },
      namaperusahaan: { required },
      alamatperusahaan: { required },
      kotaperusahaan: { required },
      provinsiperusahaan: { required },
      notlpperusahaan: { required },
      lamabekerja: { required },
      // namapasangan: {
      //   required: requiredIf(function(value) {
      //     return this.ifMarried;
      //   })
      // },
      // tmptlahirpasangan: {
      //   required: requiredIf(function(value) {
      //     return this.ifMarried;
      //   })
      // },
      // tgllahirpasangan: {
      //   required: requiredIf(function(value) {
      //     return this.ifMarried;
      //   })
      // },
      // noidentitaspasangan: {
      //   required: requiredIf(function(value) {
      //     return this.ifMarried;
      //   })
      // },
      // pendidikanpasangan: {
      //   required: requiredIf(function(value) {
      //     return this.ifMarried;
      //   })
      // },
      // pekerjaanpasangan: {
      //   required: requiredIf(function(value) {
      //     return this.ifMarried;
      //   })
      // },
      // nmperusahnpasangan: {
      //   required: requiredIf(function(value) {
      //     return this.ifMarried;
      //   })
      // },
      // almtperusahnpasangan: {
      //   required: requiredIf(function(value) {
      //     return this.ifMarried;
      //   })
      // },
      // kotaperusahnpasangan: {
      //   required: requiredIf(function(value) {
      //     return this.ifMarried;
      //   })
      // },
      // provperusahnpasangan: {
      //   required: requiredIf(function(value) {
      //     return this.ifMarried;
      //   })
      // },
      // lamabekerjapasangan: {
      //   required: requiredIf(function(value) {
      //     return this.ifMarried;
      //   })
      // },
      // emailpasangan: {
      //   required: requiredIf(function(value) {
      //     return this.ifMarried;
      //   })
      // },
      // nohandphonepasangan: {
      //   required: requiredIf(function(value) {
      //     return this.ifMarried;
      //   })
      // }
    },
  },
  data() {
    return {
      search: {
        no_kontrak: "",
        tgl_kontrak: "",
      },
      tabIndex: 0,
      model: {
        no_kontrak: "",
        uraian: "",
        tenor: 0,
        interest: 0,
        bunga_tarifthn: 0,
        denda_tarifhri:0,
        principal: 0,
        startdate: null,
        duedate: null,
        // start nasabah
        pemohon_name: "",
        tmptlahir: "",
        tgllahir: null,
        jnskelamin: "l",
        nomoridentitas: "",
        nonpwp: null,
        kewarganegaraan: "WNI",
        statusperkawinan: null,
        jmltanggungan: 0,
        pendidikanterakhir: "",
        pendidikanterakhirinput: "",
        alamatktp: "",
        kelurahanktp: "",
        kecamatanktp: "",
        kotaktp: "",
        provinsiktp: "",
        kodeposktp: "",
        alamat: "",
        kelurahan: "",
        kecamatan: "",
        kota: "",
        provinsi: "",
        kodepos: "",
        statusrmhtinggal: "",
        lamatinggalthn: 0,
        lamatinggalbln: 0,
        notlprumah: "",
        nohandphone: "",
        email: "",
        namaibu: "",
        // end nasabah
        // start referensi
        namareferensi: "",
        hubunganreferensi: "",
        alamatreferensi: "",
        kelurahanreferensi: "",
        kecamatanreferensi: "",
        kotareferensi: "",
        provinsireferensi: "",
        kodeposreferensi: "",
        notlpreferensi: "",
        nohpreferensi: "",
        //end referensi
        // start job
        tipepekerjaan: "",
        statuspekerjaan: "",
        namaperusahaan: "",
        alamatperusahaan: "",
        kotaperusahaan: "",
        provinsiperusahaan: "",
        kodeposperusahaan: "",
        notlpperusahaan: "",
        lamabekerja: null,
        kepemilikanusaha: 0,
        pekerjaansblm_tmpt: "",
        lamakerjasblm_thn: 0,
        lamakerjasblm_bln: 0,
        // end job
        // start pasangan
        namapasangan: "",
        tmptlahirpasangan: "",
        tgllahirpasangan: null,
        noidentitaspasangan: "",
        pendidikanpasangan: "",
        pekerjaanpasangan: "",
        nmperusahnpasangan: "",
        almtperusahnpasangan: "",
        kotaperusahnpasangan: "",
        provperusahnpasangan: "",
        kdposperusahnpasangan: "",
        lamabekerjapasangan: null,
        nohandphonepasangan: "",
        emailpasangan: "",
        kepmlknusahapasangan: "",
        // end pasangan
        // start penghasilan
        gaji: 0,
        totalpengeluaran: 0,
        penghasilanpasangan: 0,
        sisapendapatan: 0,
        penghasilantambahan: 0,
        totalpenghasilan: 0,
        // end penghasilan
      },
      objAgunan: {
        namajaminan: "",
        alamat: "",
        kelurahan: "",
        kecamatan: "",
        kota: "",
        provinsi: "",
        kodepos: "",
        tipejaminan: "FA",
        luastanah: 0,
        luasbangunan: 0,
        sertifikatstatus: "HM",
        otherstatussertifikat: "",
        sertifikatno: null,
        pemilikjaminan: null,
        hubungandgnpemilik: null,
        noimb: null,
        statuspbb: null,
        tanggalpbb: null,
        bpkb: null,
        stnk: null,
        statusstnk: null,
        tanggalstnk: null,
        nilaijaminan: 0,
      },
      optTipeJaminan: [
        { text: "Aset Tetap", value: "FA" },
        { text: "Kendaraan", value: "Kendaraan" },
      ],
      optStsSertifikat: [
        { text: "Hak Milik", value: "HM" },
        { text: "Hak Guna Bangunan", value: "HGB" },
        { text: "Hak Guna Usaha", value: "HGU" },
        { text: "Induk", value: "induk" },
        { text: "Lainnya", value: "lainnya" },
      ],
      optionsJK: [
        { item: "l", name: "Laki-laki" },
        { item: "p", name: "Perempuan" },
      ],
      optionsWNI: [
        { item: "WNI", name: "Indonesia" },
        { item: "WNA", name: "Warga Negara Asing" },
      ],
      optionsMarried: [
        { item: "0", name: "Menikah" },
        { item: "1", name: "Belum Menikah" },
        { item: "2", name: "Duda/Janda" },
      ],
      optionsEdu: [
        { item: "0", name: "SMA" },
        { item: "1", name: "Akademi/Diploma" },
        { item: "2", name: "S1" },
        { item: "3", name: "S2/S3" },
        { item: "4", name: "Lainnya" },
      ],
      optionsHome: [
        { item: "0", name: "Milik Keluarga" },
        { item: "1", name: "Milik Sendiri" },
        { item: "2", name: "Rumah Dinas" },
        { item: "3", name: "Kontral/Sewa" },
        { item: "4", name: "Kos" },
      ],
      optionsJob: [
        { item: "0", name: "Karyawan (Pegawai Negeri/BUMN/Swasta*)" },
        { item: "1", name: "Profesional" },
        { item: "2", name: "Wiraswasta" },
      ],
      optionsJobStatus: [
        { item: "0", name: "Pegawai Tetap" },
        { item: "1", name: "Pegawai Kontrak" },
      ],
      optionsExp: [
        { value: null, text: "-- Please select an option --", disabled: true },
        { value: ">10", text: "> 10 Tahun" },
        { value: "5-10", text: "5-10 Tahun" },
        { value: "2-5", text: "2-5 Tahun" },
        { value: "<2", text: "< 2 Tahun" },
      ],
      optionsOwner: [
        { item: "0", name: "Sendiri" },
        { item: "1", name: "Sewa" },
      ],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1: this.$store.state.user.tglaktif,
        tgl2: this.$store.state.user.akhirbln,
        sortBy: "nomor",
        sortDesc: false,
        DimCol: "Dim1",
        outstand: "1",
        idStore: this.$store.state.user.outletid,
        outletname: this.$store.state.user.outletname,
        headcategory: "",
        nmcategory: "",
      },
      listAgunan: [],
      newagunan: true,
      showObjAgunan: false,
      showDelConfirm: false,
      otherKreditDt: [
        {
          pemberipinjaman: null,
          namapeminjam: null,
          sisajangkawaktu: 0,
          saldopinjaman: 0,
          angsuran: 0,
        },
        {
          pemberipinjaman: null,
          namapeminjam: null,
          sisajangkawaktu: 0,
          saldopinjaman: 0,
          angsuran: 0,
        },
      ],
      canEdit:true,
    };
  },
  props: ["modelpinjaman"],
  async created() {
    this.model.model_pinjaman = this.modelpinjaman;
    if (this.$route.params.pinjamankey) {
      this.canEdit = false;
      const pinjamankey = this.$route.params.pinjamankey;
      const [data] = await aplikasi.detail(pinjamankey);
      const pinjaman = data[0][0];
      console.log("#pinjaman: ", pinjaman);
      this.listAgunan = data[1];

      for (var key in pinjaman) {
        this.model[key] = pinjaman[key];
      }
      this.model.jmltanggungan = pinjaman.jmltanggungan || 0;
      this.model.pemohon_name = pinjaman.CustName;
      this.model.nonpwp = pinjaman.npwp;
      this.model.tgl_kontrak = pinjaman.tgl_kontrak
        ? moment(pinjaman.tgl_kontrak).format("YYYY-MM-DD")
        : "";
      this.model.startdate = pinjaman.startdate
        ? moment(pinjaman.startdate).format("YYYY-MM-DD")
        : "";
      this.model.duedate = pinjaman.duedate
        ? moment(pinjaman.duedate).format("YYYY-MM-DD")
        : "";

      // this.otherKreditDt = pjmanlain;
      this.model.tgllahir = this.model.tgllahir
        ? moment(this.model.tgllahir).format("YYYY-MM-DD")
        : "";
      this.model.tgllahirpasangan = this.model.tgllahirpasangan
        ? moment(this.model.tgllahirpasangan).format("YYYY-MM-DD")
        : "";
    }
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "pemberipinjaman",
          label: "Pemberi Pinjaman",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "namapeminjam",
          label: "Nama Nasabah",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "sisajangkawaktu",
          label: "Sisa jangka waktu",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "saldopinjaman",
          label: "Saldo pinjaman",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "angsuran",
          label: "Angsuran",
          thClass: "text-center",
          sortable: true,
        },
      ];
      return fields;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidObjAgunan() {
      this.$v.objAgunan.$touch();
      return this.$v.objAgunan.$invalid;
    },
    ifKendaraan() {
      return this.objAgunan.tipejaminan == "Kendaraan" ? true : false;
    },
    ifFAsset() {
      return this.objAgunan.tipejaminan == "FA" ? true : false;
    },
    ifstssrtfkother() {
      return this.objAgunan.sertifikatstatus == "lainnya" ? true : false;
    },
    ifkaryawan() {
      return this.model.tipepekerjaan == "0" ? true : false;
    },
    ifMarried() {
      return this.model.statusperkawinan == "0" ? true : false;
    },
    minage() {
      const date = moment(new Date(), "DD-MM-YYYY").add("years", -17);
      return moment(date).format("YYYY-MM-DD");
    },
    ifPRK() {
      return this.modelpinjaman === "PRK" ? true : false;
    },
    ifPAB() {
      return this.modelpinjaman === "PAB" ? true : false;
    },
    fieldsAgunan() {
      const fields = [
        { key: "index", label: "#" },
        {
          key: "namajaminan",
          label: "Nama Jaminan",
          thClass: "text-center",
          thStyle: "width:500px",
        },
        {
          key: "nilaijaminan",
          label: "Nilai Jaminan",
          thClass: "text-center",
          thStyle: "width:500px",
        },

        {
          key: "alamat",
          label: "Alamat",
          thClass: "text-center",
          thStyle: "width:1500px",
        },
        {
          key: "detail",
          label: "Detail",
          thClass: "text-center",
          thStyle: "width:2000px",
        },
        {
          key: "hubungandgnpemilik",
          label: "Hubungan Dgn. peminjam",
          thClass: "text-center",
          thStyle: "width:500px",
        },
        {
          key: "action",
          label: "Action",
          thClass: "text-center",
        },
      ];
      return fields;
    },
  },
  methods: {
    async changeduedate() {
      const startdate = this.model.startdate;
      const tenor = this.model.tenor;
      const date = moment(startdate).add(tenor, "M");
      this.model.duedate = moment(date).format("YYYY-MM-DD");
    },
    tambahagunan() {
      this.newagunan = true;
      this.objAgunan = {
        namajaminan: "",
        jaminan_alamat: "",
        jaminan_kelurahan: "",
        jaminan_kecamatan: "",
        jaminan_kota: "",
        jaminan_provinsi: "",
        jaminan_kodepos: "",
        tipejaminan: "FA",
        luastanah: 0,
        luasbangunan: 0,
        sertifikatstatus: "HM",
        otherstatussertifikat: "",
        sertifikatno: "",
        pemilikjaminan: "",
        hubungandgnpemilik: "",
        noimb: "",
        statuspbb: "",
        tanggalpbb: "",
        bpkb: "",
        stnk: "",
        statusstnk: "",
        tanggalstnk: "",
        nilaijaminan: 0,
      };
      this.showObjAgunan = true;
    },
    editLineAngunan(obj) {
      this.newagunan = false;
      this.listAgunan.selected = obj;
      for (const key in obj) {
        this.objAgunan[key] = obj[key];
      }
      this.objAgunan.tanggalstnk =
        (obj.tanggalstnk || "") == ""
          ? null
          : moment(obj.tanggalstnk).format("YYYY-MM-DD");
      this.objAgunan.tanggalpbb =
        (obj.tanggalpbb || "") == ""
          ? null
          : moment(obj.tanggalpbb).format("YYYY-MM-DD");
      this.showObjAgunan = true;
    },
    async saveagunan(evt) {
      evt.preventDefault();
      if (this.invalidObjAgunan) {
        console.log("validation : ", this.$v.objAgunan);
        console.log("model obj : ", this.objAgunan);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        this.objAgunan.tanggalstnk =
          (this.objAgunan.tanggalstnk || "") == ""
            ? null
            : moment(this.objAgunan.tanggalstnk).format("YYYY-MM-DD");

        this.objAgunan.tanggalpbb =
          (this.objAgunan.tanggalpbb || "") == ""
            ? null
            : moment(this.objAgunan.tanggalpbb).format("YYYY-MM-DD");

        if (this.newagunan) {
          this.listAgunan.push(this.objAgunan);
        } else {
          for (var key in this.objAgunan) {
            this.listAgunan.selected[key] = this.objAgunan[key];
          }
        }
        this.showObjAgunan = false;
      }
    },
    async deleteConfirm() {},
    async delAgunan(index) {
      if (this.listAgunan.length > 1) {
        if (index > -1) {
          this.listAgunan.splice(index, 1);
        }
        this.listAgunan.total = this.listAgunan.length;
      } else {
        toastr.warn("Angunan tidak bisa kosong!", "Perhatian");
      }
    },
    async addpinjaman() {
      try {
        if (this.invalidModel) {
          console.log("validation : ", this.$v.issuedLinesObj);
          console.log("model obj : ", this.issuedLinesObj);
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        } else if (this.listAgunan.length == 0) {
          this.tabIndex = 2;
          toastr.error("Harap masukkan data agunan", "ERROR MESSAGE");
        } else {
          this.model.otherKreditDt = this.otherKreditDt;
          this.model.listAgunan = this.listAgunan;
          this.model.tgllahir = moment(this.model.tgllahir).format(
            "YYYY-MM-DD"
          );
          this.model.tgllahirpasangan = moment(
            this.model.tgllahirpasangan
          ).format("YYYY-MM-DD");

          await aplikasi.save(this.model);
          toastr.success("Data pinjaman berhasil disimpan", "Info");
          this.close();
        }
      } catch (error) {
        console.log("error : ", error);
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    addpinjamanother() {
      this.otherKreditDt.push({
        pemberipinjaman: null,
        namapeminjam: null,
        sisajangkawaktu: 0,
        saldopinjaman: 0,
        angsuran: 0,
      });
    },
    close() {
      router.push({ name: "loan.pinjaman" });
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  margin-top: 4px !important;
}
.input-group {
  margin-top: 2px;
}
.lbl-left {
  width: 200px !important;
}
.sub-section-input {
  margin-left: 200px;
  width: calc(100% - 200px);
}
.sub-section-label {
  width: 150px;
}
.mynumb-penghasilan {
  max-width: 200px;
}
</style>